// SectionHeader.jsx

import React from 'react';

// Device Detection
import { useIsMobile } from 'hooks/useDeviceDetect';

// CSS
import './SectionHeader.css';

/**
 * SectionHeader
 * 
 * Section header component.
 * 
 * @param {ReactNode} children - Optional content to display within the section header.
 * 
 * @returns {ReactNode} SectionHeader component.
 */
const SectionHeader = React.memo(({ children }) => {

  // ----- DEVICE DETECTION ----- //

  const isMobile = useIsMobile();

  // ----- RENDER ----- //

  return (

    <div
      className="section-header-container"
      style={{
        paddingLeft: isMobile ? 12 : 0,
        paddingRight: isMobile ? 12 : 0,
      }}
    >

      {children}

    </div>

  );
});

// Dev Tools
SectionHeader.displayName = 'SectionHeader';

export default SectionHeader;
